<template>
  <div>
    <div class="row justify-content-end mb-3">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'users-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer un nouvel utilisateur
        </button>
      </div>
    </div>

    <vue-data-table
      :headers="headers"
      :data="authentications"
      :items-per-page="25"
      :table-actions="tableActions"
    >
      <template #cell-status="{ row }">
        <span
          :class="{
            'badge bg-success': row.status === 'success',
            'badge bg-danger': row.status === 'failed',
            'badge bg-warning':
              row.status !== 'success' && row.status !== 'failed',
          }"
        >
          {{ row.status }}
        </span>
      </template>

      <template #cell-country="{ row }">
        {{ row.country }} ({{ row.countryCode }})
      </template>

      <template #cell-region="{ row }">
        {{ row.regionName || row.region }}
      </template>

      <template #cell-ip="{ row }">
        <code>{{ row.query }}</code>
      </template>

      <template #cell-is_authorized="{ row }">
        <span
          :class="{
            'badge bg-success': row.is_authorized,
            'badge bg-danger': !row.is_authorized,
          }"
        >
          {{ row.is_authorized ? 'Oui' : 'Non' }}
        </span>
      </template>

      <template #cell-created_at="{ row }">
        {{
          row.created_at
            ? new Date(row.created_at).toLocaleString('fr-FR')
            : '—'
        }}
      </template>

      <template #cell-actions="{ row }">
        <div class="btn-group">
          <button
            v-if="!row.is_authorized"
            @click="addToAllowedIPs(row)"
            class="btn btn-sm btn-success"
            title="Ajouter aux IPs autorisées"
          >
            <i class="bi bi-shield-check"></i>
            Autoriser IP
          </button>
          <button
            v-else
            @click="removeFromAllowedIPs(row)"
            class="btn btn-sm btn-danger"
            title="Retirer des IPs autorisées"
          >
            <i class="bi bi-shield-x"></i>
            Désautoriser IP
          </button>
        </div>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      headers: [
        { field: 'id', label: 'ID', class: 'text-center' },
        { field: 'status', label: 'Statut', class: 'text-center' },
        { field: 'country', label: 'Pays' },
        { field: 'region', label: 'Région' },
        { field: 'city', label: 'Ville' },
        { field: 'lat', label: 'Latitude', class: 'text-center' },
        { field: 'lon', label: 'Longitude', class: 'text-center' },
        { field: 'ip', label: 'IP', class: 'text-center' },
        { field: 'isp', label: 'ISP' },
        { field: 'is_authorized', label: 'Autorisé', class: 'text-center' },
        { field: 'created_at', label: 'Créé à', class: 'text-center' },
        { field: 'actions', label: 'Actions', class: 'text-center' },
      ],
    };
  },
  computed: {
    ...mapGetters('auth', {
      authentications: 'getAllAuthentications',
    }),
    ...mapGetters('allowedIp', {
      allowedIPs: 'getAllowedIPs',
    }),
    tableActions() {
      return [
        {
          title: 'Actualiser',
          class: 'btn-secondary',
          icon: 'bi bi-arrow-clockwise',
          action: () => this.refresh(),
        },
      ];
    },
  },
  mounted() {
    this.$store.dispatch('auth/fetchAllAuthentications');
    this.$store.dispatch('allowedIp/getAll');
  },
  methods: {
    async refresh() {
      await this.$store.dispatch('auth/fetchAllAuthentications');
      await this.$store.dispatch('allowedIp/getAll');
    },

    async addToAllowedIPs(authentication) {
      try {
        await this.$store.dispatch('allowedIp/store', {
          ip_address: authentication.query,
        });
        // Refresh the authentications list to update the is_authorized status
        await this.refresh();
        this.$toast.success('IP autorisée avec succès');
      } catch (error) {
        console.error('Error adding IP to allowed list:', error);
        this.$toast.error('Erreur lors de l\'autorisation de l\'IP');
      }
    },

    async removeFromAllowedIPs(authentication) {
      // Skip if IP is "Unknown" or invalid
      if (!authentication.query || authentication.query === 'Unknown') {
        this.$toast.error('Adresse IP invalide');
        return;
      }

      const ipAddress = authentication.query;

      try {
        // Call destroyByIpAddress action which uses $api.delete from axios plugin
        // The plugin handles confirmation and loading automatically
        await this.$store.dispatch('allowedIp/destroyByIpAddress', ipAddress);

        // Wait a bit for backend processing
        await new Promise(resolve => setTimeout(resolve, 300));

        // Refresh authentications list to update the is_authorized status
        await this.$store.dispatch('auth/fetchAllAuthentications');
      } catch (error) {
        console.error('Error removing IP from allowed list:', error);
        const errorMessage = (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'Erreur lors de la désautorisation de l\'IP';
        this.$toast.error(errorMessage);
      }
    },
  },
};
</script>

<style scoped>
code {
  background-color: #f8f9fa;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.9rem;
}
</style>
